/**
 * Redux Store Configuration
 * Centralized state management with Redux Toolkit
 */

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import jobsReducer from "./slices/jobsSlice";
import uiReducer from "./slices/uiSlice";
import chatReducer from "./slices/chatSlice";
import settingsReducer from "./slices/settingsSlice";
import llmConfigsReducer from "./slices/llmConfigsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    jobs: jobsReducer,
    ui: uiReducer,
    chat: chatReducer,
    settings: settingsReducer,
    llmConfigs: llmConfigsReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["jobs/uploadProgress"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

// Infer types from store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
